import React from 'react'

import CreditOptionsBanner from '../CreditOptionsBanner/CreditOptionsBanner'

import * as Styled from './CreditOptionsMessage.styles'

const TermsAndConditions = () => {
  const href = '//www.argos.co.uk/webapp/wcs/stores/servlet/ArgosFSTermsConditionsView?storeId=10151&langId=110'
  const target = '_blank'
  const text = 'Ts & Cs apply'

  return <Styled.TermsLink {...{ href, target }}>{text}</Styled.TermsLink>
}

export default class CreditOptionsMessageContent extends React.Component {
  render() {
    const { periodDuration, periodType, isBuyNowPayLater, apr, dataTest } = this.props
    return (
      <Styled.Message>
        <Styled.Banner>
          <CreditOptionsBanner periodDuration={periodDuration} periodType={periodType} apr={apr} />
        </Styled.Banner>
        <Styled.BuyToday data-test={`${dataTest}-content-info`}>
          <h3>{isBuyNowPayLater ? 'Buy Now, Pay Later' : 'Buy it today and pay later'}</h3>
          <Styled.CreditOptions>
            <strong>What you need to know:</strong>
            <ol>
              <li>
                <strong>Get an instant decision</strong> when you apply for an Argos Card today!
              </li>
              <li>Check if you&apos;ll be accepted without impacting your credit score.</li>
              <li>
                Enjoy your product and benefit from <strong>paying at your own pace.</strong>
              </li>
              <li>
                You&apos;ll also get a credit limit that you can use on future purchases and there&apos;s no need to
                apply again.
              </li>
            </ol>

            <strong>How does interest work?</strong>
            <ol>
              <li>
                You can put any order on Normal Credit and if you clear your balance before your next statement date,
                and keep your accounts up to date, you&apos;ll incur no interest.
              </li>
              <li>
                If your items qualify for Buy Now, Pay Later, no interest will be charged if you pay in full within your
                credit plan period and keep your account up to date.
              </li>
              <li>
                If you decide to spread the cost further you will be charged interest on the remaining balance,
                backdated to the date of purchase (this is known as deferred interest)
              </li>
            </ol>

            <strong>How to manage your plan:</strong>
            <ol>
              <li>
                With the easy to use <strong>Argos Card App</strong>, you&apos;re in control of your account. Manage
                your payment plans and keep up to date with the latest offers.
              </li>
              <Styled.Terms>
                <a href='/help/argos-card/credit-plan-info'>Find out more.</a>
              </Styled.Terms>
            </ol>
          </Styled.CreditOptions>
        </Styled.BuyToday>
      </Styled.Message>
    )
  }
}

export { TermsAndConditions }
